<template><section><template>
<h3>时间选择器</h3>
<div class="bs-docs-section">
<div class="bs-example">
<n3-timepicker v-model="value" format="hh:mm:ss"></n3-timepicker>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-timepicker</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span>  <span class="hljs-attr">format</span>=<span class="hljs-string">"hh:mm:ss"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-timepicker</span>&gt;</span>
</code></pre>
<h3>参数</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>format</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">hh:mm:ss</code></td>
<td>格式</td>
</tr>
<tr>
<td>hour-range</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">[0,60]</code></td>
<td>小时范围</td>
</tr>
<tr>
<td>minute-range</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">[0,60]</code></td>
<td>分钟范围</td>
</tr>
<tr>
<td>second-range</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">[0,60]</code></td>
<td>秒范围</td>
</tr>
<tr>
<td>readonly</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">true</code></td>
<td>是否只读</td>
</tr>
<tr>
<td>disabled</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>是否可用</td>
</tr>
</tbody>
</table>
<h3>事件</h3>
<table>
<thead>
<tr>
<th>名称</th>
<th>说明</th>
<th>参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>hide</td>
<td>隐藏</td>
<td>(currentValue)</td>
</tr>
<tr>
<td>change</td>
<td>改变</td>
<td>(currentValue)</td>
</tr>
</tbody>
</table>
</div>
</template>

</section></template>

<script>

export default {
  methods: {
    hide (val) {
      console.log(val)
    }
  },
  data () {
    return {
      value: '',
      value1: ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3TimepickerDocs.md?321c0428